exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/*test svn*/\n\n/*styles for home content only*/\n.profile-wrapper {\n  margin-top: 10px;\n}\n.book-toolbar-section{\n\n}\n\n.service-profile-section{\n\n  width: 100%;\n  min-height: 300px;\n  background-color: #fff;\n  /*border: 1px solid #cfcfcf;*/\n  float: left;\n  border: 1px solid #e0e0e0;\n\n}\n\n@media (max-width: 767px) {\n  .service-profile-section{\n    width: 100%;\n    min-height: 90px;\n    max-height: 95px;\n    background-color: #fff;\n    border: 1px solid #cfcfcf;\n    position: fixed;\n    z-index: 100;\n    top: 40px;\n    right: 0px;\n    overflow: hidden;\n    box-shadow: 0px 1px 5px -3px grey;\n    padding-top: 15px;\n    padding-right: 10px;\n\n  }\n\n  .book-toolbar-section {\n    margin-top: 70px;\n  }\n\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/app/+book/book.component.css
// module id = 1122
// module chunks = 0